module.exports = __webpack_public_path__ + "img/certTJ3.418f799d.jpg";